// import { getBaseUrl } from "./config";

// declare const BASE_URL: string;

export enum AddInMode {
  Essentials = "essentials",
  Advanced = "advanced",
  OnPrem = "onprem",
}

/**
 * Determines the add-in mode (Essentials, Advanced or OnPrem) based on the 'e' URL parameter.
 * It reads the current window's URL, checks for the 'e' query parameter,
 * and returns the corresponding AddinMode. Defaults to Essentials if the parameter
 * is missing or invalid.
 * @returns A Promise that resolves to the determined AddinMode.
 */
export async function getAddinModeFromUrl(): Promise<AddInMode> {
  const currentUrl = new URL(window.location.href);
  // Get the URLSearchParams object
  const params = new URLSearchParams(currentUrl.search);

  // Retrieve a specific parameter by its name
  const modeParam = params.get("e")?.toLowerCase();

  switch (modeParam) {
    case AddInMode.Advanced:
      console.log("Add-in started with mode (from manifest):", AddInMode.Advanced);
      return AddInMode.Advanced;
    case AddInMode.Essentials:
      console.log("Add-in started with mode (from manifest):", AddInMode.Essentials);
      return AddInMode.Essentials;
    case AddInMode.OnPrem:
      console.log("Add-in started with mode (from manifest):", AddInMode.OnPrem);
      return AddInMode.OnPrem;
    default:
      console.log("Add-in started with invalid or no mode (from manifest). Defaulting to Essentials.");
      return AddInMode.Essentials; // Default to Essentials if 'e' parameter is not present or invalid
  }
}

/**
 * Constructs a local URL for the web page for the given path.
 * @param path The path to construct a local URL for.
 * @returns
 */
export function createLocalUrl(path: string) {
  // const baseUrl = getBaseUrl();
  // const baseUrl = "https://storage.googleapis.com/pgpoutlookaddin/";
  // return `${baseUrl}${path}`;

  // By using the URL constructor with the current page's location as the base,
  // we can create a full URL for any other asset in our add-in without
  // needing to know the base path. The browser handles resolving the relative
  // path correctly.
  const localURL = new URL(path, window.location.href).href;
  console.log("Local URL:", localURL);
  return localURL;
}
